var _defs, _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCssColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "46b9a163a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81.136719 96 L 294.136719 96 L 294.136719 337.5 L 81.136719 337.5 Z M 81.136719 96 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "43c7a91214"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 131 37.5 L 164 37.5 L 164 78 L 131 78 Z M 131 37.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bfaff3f200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 170 37.5 L 203 37.5 L 203 79 L 170 79 Z M 170 37.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "29a9d01a60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 208 37.5 L 242 37.5 L 242 79 L 208 79 Z M 208 37.5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46b9a163a7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#264de4",
    d: "M 187.542969 337.492188 L 100.636719 313.398438 L 81.269531 96.457031 L 294.078125 96.457031 L 274.699219 313.363281 L 187.546875 337.488281 Z M 187.542969 337.492188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2965f1",
    d: "M 258.101562 299.550781 L 274.667969 114.195312 L 187.679688 114.191406 L 187.679688 319.042969 Z M 258.101562 299.550781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 125.671875 194.65625 L 128.058594 221.257812 L 187.679688 221.257812 L 187.679688 194.65625 Z M 125.671875 194.65625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 120.871094 140.796875 L 123.292969 167.40625 L 187.679688 167.40625 L 187.679688 140.796875 Z M 120.871094 140.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 187.679688 263.753906 L 187.5625 263.789062 L 157.890625 255.78125 L 155.992188 234.5625 L 129.25 234.5625 L 132.980469 276.34375 L 187.554688 291.472656 L 187.679688 291.4375 Z M 187.679688 263.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#43c7a91214)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 131.355469 37.5 L 163.625 37.5 L 163.625 50.976562 L 144.847656 50.976562 L 144.847656 64.453125 L 163.625 64.453125 L 163.625 77.929688 L 131.355469 77.929688 Z M 131.355469 37.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bfaff3f200)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 170.078125 37.5 L 202.34375 37.5 L 202.34375 49.21875 L 183.574219 49.21875 L 183.574219 51.5625 L 202.34375 51.5625 L 202.34375 78.515625 L 170.078125 78.515625 L 170.078125 66.210938 L 188.855469 66.210938 L 188.855469 63.867188 L 170.078125 63.867188 Z M 170.078125 37.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#29a9d01a60)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 208.800781 37.5 L 241.066406 37.5 L 241.066406 49.21875 L 222.289062 49.21875 L 222.289062 51.5625 L 241.066406 51.5625 L 241.066406 78.515625 L 208.800781 78.515625 L 208.800781 66.210938 L 227.570312 66.210938 L 227.570312 63.867188 L 208.800781 63.867188 Z M 208.800781 37.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 249.515625 194.65625 L 254.324219 140.796875 L 187.585938 140.796875 L 187.585938 167.40625 L 225.125 167.40625 L 222.707031 194.65625 L 187.585938 194.65625 L 187.585938 221.257812 L 220.394531 221.257812 L 217.300781 255.765625 L 187.585938 263.777344 L 187.585938 291.453125 L 242.203125 276.34375 L 242.601562 271.84375 L 248.867188 201.796875 Z M 249.515625 194.65625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssColor);
export default __webpack_public_path__ + "static/media/css-color.7c3cf6738d4b7b48c95c15fea9e282a4.svg";
export { ForwardRef as ReactComponent };